<template>
  <v-col :cols="btnParc ? 12 : 3" :class="btnParc ? 'pt-0' : '' ">
    <template v-if="btnParc">
      <input-text v-show="false" label="Parcelas" v-model="model" required />
      <v-label>Parcelas:</v-label>
      <v-item-group required v-model="model" @change="change">
        <v-row>
          <v-col :cols="parseInt(12/parcelas.length)" v-for="(item, i) in parcelas" :key="i">
            <v-item v-slot="{ active, toggle }" :value="item.value">
              <v-btn block large tile @click="toggle" :color="active? 'grey darken-3' : ''" class="px-4 text-lowercase" :dark="active">
                {{item.text}}
              </v-btn>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </template>
    <input-select v-else :options="parcelas" required name="Parcelas" label="Parcelar em até:" v-model="model" @change="change"></input-select>
  </v-col>
</template>

<script>
export default {
  props: {
    value: null
  },
  data () {
    return {
      parcelas: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    btnParc: function () {
      return this.parcelas.length < 6
    }
  },
  methods: {
    change (value) {
      this.$emit('change', value)
    },
    setParcela (loading) {
      const ultima = this.parcelas && this.parcelas.length > 0 ? this.parcelas[this.parcelas.length - 1].value : null
      if (!loading && this.model.Parcelas > ultima) { this.$set(this.model, 'Parcelas', ultima) }
    }
  },
  beforeMount () {
    const th = this
    th.$api.Multiplo.Post('ListProdutoRedeParcela', {}).then(function (response) {
      th.parcelas = []
      response = response.filter(item => item !== 18)
      for (var i = 0; i < response.length; i++) {
        var obj = { value: response[i], text: response[i] + 'x' }
        th.parcelas.push(obj)
      }
      th.setParcela(true)
      th.$emit('load', th.parcelas.length < 6)
    })
  }
}
</script>
